import type { Components, Theme } from '@mui/material/styles';
import { varAlpha } from 'minimal-shared/utils';

// ----------------------------------------------------------------------

const MuiBackdrop: Components<Theme>['MuiBackdrop'] = {
  /** **************************************
   * STYLE
   *************************************** */
  styleOverrides: {
    root: ({ theme }) => ({
      backgroundColor: varAlpha(theme.vars.palette.grey['800Channel'], 0.48),
      backdropFilter: 'blur(3px)',
      WebkitBackdropFilter: 'blur(3px)',
    }),
    invisible: { background: 'transparent', backdropFilter: 'none', WebkitBackdropFilter: 'none' },
  },
};

// ----------------------------------------------------------------------

export const backdrop = { MuiBackdrop };
